import axios from 'axios';
import { useEffect, useState } from 'react';
import {app} from '../config'
import { getTokenfromUserObj } from '../utils/getTokenfromObj';
let url=`${app.URL}/org/fetchall`;
const useFetchUserPermissions = () => {
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const token=getTokenfromUserObj()
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.post(`${app.URL}/roleperm/view`,{},{headers:{auth:token}});
        setResponse(res.data);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return { loading, response, error };
};

export default useFetchUserPermissions;
